﻿
// js dependencies...
import 'jquery';
import 'bootstrap';
import 'parsleyjs';
import 'slick-carousel';
import 'parsleyjs'

// pollyfills
import './libs/details-pollyfill';
import './libs/focus-within-polyfill';

// custom js depenencies...
import './modules/homepage-carousel';
import './modules/image-slider';
import './modules/text-slider';
import './modules/sticky-masthead';
import './modules/burger-menu';
import './modules/nav-section-toggles';
import './modules/number-spin';
import './modules/at-a-glance-map';
import './modules/strategy-browser';
import './modules/leadership-toggle';
import './modules/values-browser';
import './modules/form-toggle';
import './modules/form-slider';
import './modules/call-registration';

import './modules/graph-animation';
import './modules/table-filter';
// do not use this just yet, it needs more work
// import './modules/nav-drop-sizer';

// loaders have been added to webpack for .css, woff/woff2, .ttf & .svg
// import any here that are to be bundled
